<template>
    <div>
        <div class="relative h-1/2">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 68 30"
                fill="none"
                width="68"
                height="30"
                class="absolute left-1/2 top-0 z-20 -translate-x-1/2">
                <path
                    d="M33.6261 1.15397L2.24565 14.0753C1.41998 14.4153 1.41998 15.5847 2.24565 15.9247L33.6125 28.8404C33.8604 28.9425 34.1389 28.9408 34.3855 28.8356L65.7657 15.4529C66.5871 15.1026 66.5724 13.9332 65.7424 13.6036L34.3759 1.14923C34.1348 1.05351 33.8659 1.05521 33.6261 1.15397Z"
                    fill="white"
                    stroke="currentColor"
                    stroke-width="2" />
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 36 87"
                fill="none"
                width="36"
                height="87"
                class="absolute right-full z-30 transition-transform duration-300 group-hover/menuItem:-translate-x-3 group-hover/menuItem:translate-y-3">
                <path
                    d="M1 15.6697C1 15.2645 1.24455 14.8993 1.61925 14.745L33.6192 1.56854C34.2774 1.29753 35 1.78144 35 2.49322V84.527C35 85.2334 34.2875 85.7171 33.631 85.4564L1.63097 72.7505C1.25006 72.5993 1 72.2309 1 71.8211L1 15.6697Z"
                    fill="white"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35 13.8956C35 13.2107 34.327 12.7285 33.6785 12.9488L1.67846 23.8149C1.27284 23.9527 1 24.3334 1 24.7618V44.6363C1 45.1324 1.3637 45.5535 1.85451 45.6257L33.8545 50.3315C34.4582 50.4203 35 49.9524 35 49.3422V13.8956Z"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    d="M18 8L18 79"
                    stroke="currentColor"
                    stroke-width="2" />
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 36 87"
                fill="none"
                width="36"
                height="87"
                class="absolute left-full z-30 transition-transform duration-300 group-hover/menuItem:translate-x-3 group-hover/menuItem:translate-y-3">
                <path
                    d="M35 71.3303C35 71.7355 34.7555 72.1007 34.3808 72.255L2.38075 85.4315C1.72258 85.7025 1 85.2186 1 84.5068L1.00001 2.473C1.00001 1.76661 1.71252 1.2829 2.36904 1.54358L34.369 14.2495C34.7499 14.4007 35 14.7691 35 15.1789L35 71.3303Z"
                    fill="white"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.34278 12.99C1.69042 12.7519 1 13.2349 1 13.9294V49.3515C1 49.9585 1.53636 50.4255 2.13757 50.342L18.1376 48.1198C18.632 48.0511 19 47.6284 19 47.1293V19.7676C19 19.3475 18.7374 18.9722 18.3428 18.8282L2.34278 12.99Z"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    d="M30.8135 40L30.8135 49"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round" />
                <path
                    d="M29.8135 70L23.8135 72"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round" />
                <path
                    d="M19 8L19 79"
                    stroke="currentColor"
                    stroke-width="2" />
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts"></script>
